interface Props {
  color: string;
  size: number;
}

export function SensorPlus({ color, size }: Props) {
  return (
    <svg width={22 * size} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11.4" cy="11.4" r="10.45" fill="white" stroke={color} strokeWidth="1.1" />
      <circle cx="11.4" cy="11.4" r="11.2" stroke="#323B37" strokeWidth="0.4" />
      <circle cx="11.4" cy="11.4" r="7" fill={color} />
      <line
        x1="11.4"
        y1="8.89999"
        x2="11.4"
        y2="13.9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="13.9"
        y1="11.405"
        x2="8.89999"
        y2="11.405"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
